import React, { useEffect, useState } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

import { ChatSection } from "../utils/home/chat-section";
import { UserProfile } from "../utils/home/user-profile";
import { assetImages } from "../../constants/assets";
import { useNavigate } from "react-router-dom";
import { fontSizes } from "../../theme/font-sizes";
import TutorialGrid from "../utils/community/tutorial-grid";

import ImageBox from "../utils/community/image-box";
import ImageOverlayText from "../utils/community/image-overlay-text";
import routes from "../../constants/routes";
import MatchFinder from "../utils/finding-match-timer";
import apiRoutes from "../../api/routes";
import useApiRequest from "../../api/api";
import NewsPageSkeleton from "./community-news-skeleton";

export default function CommunityComponent() {
  const navigate = useNavigate();
  const theme = useTheme();
  const { makeApiCall } = useApiRequest();
  const [isLoading, setIsLoading] = useState(false);
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const handleNavigateToRace = (id) => {
    navigate(`${routes.race}?id=${id}`);
    // Perform navigation or additional logic if required
  };
  const [tutorials, setTutorials] = useState([]);

  const fetchNews = async () => {
    setIsLoading(true);

    try {
      const response = await makeApiCall(apiRoutes.community.list, "GET");
      if (response?.data) {
        const fetchedTutorials = response.data.map((item) => ({
          id: item.identifier, // Use unique identifier from API
          category: item.tag,
          title: item.title,
          description: item.description,
          image: item.coverImage,
        }));

        setTutorials(fetchedTutorials); // Update state with transformed data
      }
    } catch (error) {
      console.error("Failed to fetch races:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);
  const navigateToArticle = (id) => {
    navigate(`${routes.communityArticle}?id=${id}`);
  };
  return (
    <>
      {isLoading ? (
        <NewsPageSkeleton isMediumScreen={isMediumScreen} />
      ) : (
        <Box
          sx={{
            display: "flex",
            height: "100vh",
          }}
        >
          {/* Left side - scrollable content */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              m: isMediumScreen ? 3.5 : "15px",
              mt: 0,
              pt: 6,
              ml: isMediumScreen ? 3.5 : "38px",
              borderRadius: "12px",
              mb: 2,
              "&::-webkit-scrollbar": {
                display: "none", // Hide scrollbar in WebKit browsers (Chrome, Safari)
              },
            }}
          >
            <ImageBox
              isMediumScreen={isMediumScreen}
              assetImages={
                isMediumScreen
                  ? assetImages.mobCommunity
                  : assetImages.community
              }
            >
              <ImageOverlayText
                imageUrl={assetImages.community}
                isMediumScreen={isMediumScreen}
              />
            </ImageBox>

            {/* Profile Section */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
                alignItems: "start",
                mb: 4,
                textAlign: "left",
              }}
            >
              <Typography
                fontFamily={"MontserratBold"}
                fontSize={fontSizes.heading2}
                sx={{ mt: 2, color: "white" }}
              >
                News
              </Typography>
            </Box>

            <TutorialGrid
              tutorials={tutorials}
              isMediumScreen={isMediumScreen}
              onClick={navigateToArticle}
            />
          </Box>

          {/* Right side - fixed content */}
          {!isMediumScreen && (
            <Box
              sx={{
                width: { lg: 370, sm: 300 },
                p: 3,
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none", // Hide scrollbar in WebKit browsers (Chrome, Safari)
                },
              }}
            >
              <UserProfile
                username="@ExHuma64"
                avatarSrc="/placeholder.svg?height=40&width=40"
                balance={231}
              />
              <Box mt={3}></Box>
              <ChatSection />

              {/* Find Random Match Button */}
              <Box
                display={"flex"}
                justifyContent={"left"}
                mt={2}
                sx={{ mb: 11 }}
              >
                <MatchFinder
                  onNavigate={handleNavigateToRace} // Custom navigation logic
                />
              </Box>
            </Box>
          )}
        </Box>
      )}
    </>
  );
}
